import { render, staticRenderFns } from "./BarDocument.vue?vue&type=template&id=27bd670a&"
import script from "./BarDocument.vue?vue&type=script&lang=js&"
export * from "./BarDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports